import { ViolenciaComponent } from './reporte/violencia/violencia.component';
import { AplicacionComponent } from './aplicacion/aplicacion.component';
import { Routes, RouterModule, Route } from "@angular/router";
import { DetalleComponent } from './detalle/detalle.component';
import { DetalleResolver } from './detalle/detalle.resolver';
import { HomeComponent } from './home.component';
import { MesaAyudaComponent } from './mesa-ayuda/mesa-ayuda.component';
import { AboutComponent } from './about/about.component';
import { EmailComponent } from './email/email.component';
import { FaltantesComponent } from './reporte/faltantes/faltantes.component';
import { CumplesComponent } from './cumples/cumples.component';
import { EmergenciaComponent } from './reporte/emergencia/emergencia.component';
import { BuscadorPersonasComponent } from './buscador-personas/buscador-personas.component';


const fallbackRoute: Route = {
	path: '**',
	redirectTo: 'inicio'
}

const mesaAyudaRoute: Route = {
	path: 'mesa-ayuda',
	children: [
		{
			path: '',
			component: MesaAyudaComponent,
		},
		{
			path: 'sistemas-informaticos',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Sistemas Informáticos',
					link: false
				}
			}
		},
		{
			path: 'empadronamiento',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Empadronamiento',
					link: false
				}
			}
		},
		{
			path: 'recursos-humanos',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Recursos Humanos',
					link: false
				}
			}
		},
		{
			path: 'ingenieria-planta',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Ingeniería de Planta',
					link: false
				}
			}
		},
		{
			path: 'comunicacion',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Comunicación',
					link: false
				}
			}
		},
		{
			path: 'nuevo-equipamiento',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Nuevo Equipamiento',
					link: false
				}
			}
		},
		{
			path: 'gerencia-comercial',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Gerencia Comercial',
					link: false
				}
			}
		},
		{
			path: 'gestion-implantes',
			loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
			data: {
				breadcrumb: {
					label: 'Gestión de Implantes',
					link: false
				}
			}
		}
	],
	data: {
		breadcrumb: {
			label: 'Mesa de Ayuda'
		}
	}
}

export const reportesRoute: Route = {
	path: 'reportes',
	children: [
		{
			path: 'emergencias',
			component: EmergenciaComponent,
			data: {
				breadcrumb: {
					label: '8700 Emergencias',
				}
			}
		},
		{
			path: 'violencia-laboral',
			children: [
				{
					path: '',
					component: ViolenciaComponent,
				},
				{
					path: 'incidencia',
					loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
					data: {
						breadcrumb: {
							label: 'Incidencia',
							link: false
						}
					}
				}
			],
			data: {
				breadcrumb: {
					label: 'Violencia Laboral',
				}
			}
		},
		{
			path: 'faltantes',
			children: [
				{
					path: '',
					component: FaltantesComponent,
				},
				{
					path: 'incidencia',
					loadChildren: () => import('../legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule ),
					data: {
						breadcrumb: {
							label: 'Incidencia',
							link: false
						}
					}
				}
			],
			data: {
				breadcrumb: {
					label: 'Faltantes',
				}
			}
		}
	],
	data: {
		breadcrumb: {
			label: 'Reportes',
			link: false
		}
	}
}

export const homeRouteConfig: Routes = [
	{
		path: 'inicio',
		component: HomeComponent,
		data: {
			breadcrumb: {
				label: 'Inicio'
			}
		}
	},
	{
		path: 'aplicaciones',
		component: AplicacionComponent
	},
	{
		path: 'correos-electronicos',
		component: EmailComponent
	},
	{
		path: 'noticia/:rid',
		component: DetalleComponent,
		resolve: { detalle: DetalleResolver },
		data: {
			breadcrumb: {
				label: 'Noticia',
				link: false
			}
		}
	},
	{
		path: 'acerca-de-comunita',
		component: AboutComponent,
		data: {
			breadcrumb: {
				label: 'Acerca de Comunità',
				link: false
			}
		}
	},
	{
		path: 'cumpleaños',
		component: CumplesComponent
	},
	/*
	{
		path: 'buscador-personas',
		component: BuscadorPersonasComponent
	},
	*/
	reportesRoute,
	mesaAyudaRoute,
	fallbackRoute
];
